const Code=()=>{
        return Math.ceil(Math.random() * 9001) + 999
}
export  {Code}